<template>

  <div class="my-school-container" :key="updateKey">
    <div :class='{"no-opacity":!school.active}'><b>{{$t('language.current_loggedin')}}</b></div>
   
      <br>
  <ui-input title="language.provide_url" type="text" autocapitalize="none"  v-bind:val="school.url" @input="(v)=>{url = v;change();}">
     <div class="www" slot="left">www.</div>
        <div slot="icons">
          <ui-icon v-if="isSecure()" v-on:click.native="secureAlert()" v-bind:style="{fontSize:'0.75em',margin:'0'}" backgroundColor="#000000" color="#FFFFFF" icon="shield-alt"></ui-icon>
        </div>
      </ui-input>
      <ui-input title="language.provide_email" type="email" autocapitalize="none"  v-bind:val="school.username" @input="(v)=>{username = v; change();}"></ui-input>
      <ui-input title="language.provide_password" :type="computePaswordInputType" autocapitalize="none" v-bind:val="school.password" @input="(v)=>{password = v;change();}">
        <div slot="icons"><font-awesome-icon class="icon" @click="togglePasswordShow()" :icon="computeEyeIcon" /></div>
      </ui-input>
      
      <button-activate :active="button_active" class="btn" :class="{'btn-visible': computeVisible}" v-on:click.native="login()" title="language.login_school_button"/>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import { modalService } from '../services/ModalService.js';
import ButtonActivate from '../components/buttons/ButtonActivate.vue';
import UiIcon from '../components/UiIcon.vue';
import UiInput from '../components/UiInput.vue';

import i18n from "../language.js";
import { eventBus } from '../services/EventBus.js';

export default {
  name: 'my-school',
  props:{
    school:{},
  },
  data(){
    return {
      updateKey:0,
      show_password:false,
      button_active:true,
      username:"",
      password:"",
      url:"",
      updated:false,
    }
  },
  computed:{
  ...mapState([
    'user_schools','loggedIn'
    ]),
    computeVisible(){
      if(!this.school.active){
        return true;
      }

      if(this.school.active && !this.updated)
      {
         return false;
      }
      
      if(this.school.active || this.updated)
      {
         return true;
      }
      

      return true;

    },
    computeEyeIcon(){
         if(this.show_password){
           return 'eye-slash'
         }else{
           return 'eye'
         }
       },
    computePaswordInputType(){
         if(this.show_password){
           return 'text'
         }else{
           return 'password'
         }
       },
  },
  mounted(){
    this.username=this.school.username;
    this.password=this.school.password;
    this.url=this.school.url;
  },
  components:{
    ButtonActivate,
    UiIcon,
    UiInput,
  },
  methods:{
    update(){
      var copiedSchool=JSON.parse(JSON.stringify(this.school));
      // copy school]
      var credentials=JSON.parse(JSON.stringify(this.school));
      credentials.username=this.username;
      credentials.password=this.password;
      credentials.url=this.url;

      this.button_active=false;

      this.$store.dispatch('update_school',{school:this.school, credentials:credentials}).then(
        ()=>{
          this.updated=false;
          this.button_active=true;
          this.$store.dispatch('setActiveSchool', this.school );

          this.login_done();
        },
      ()=>{
        //alert("could not")
        this.updated=false;
        this.button_active=true;

        this.school.url=copiedSchool.url;
        this.school.username=copiedSchool.username;
        this.school.password=copiedSchool.password;
        this.updateKey=new Date().getTime();
      });

      /*
      // copy and save old school
      
      
      // remove school
      this.$store.dispatch('addSchool',{school:school}).then(()=>{
        // school added and logged in
        // delete the old school
        this.updated=false;
        this.$store.dispatch('removeSchoolSilent',{school:this.school});
        
        
      },()=>{
       
        this.updated=false;
       // restore values
       this.school.url=saved_school.url;
      this.school.username=saved_school.username;
      this.school.password=saved_school.password;
       this.updateKey=new Date().getTime();

      })

      */
    },
    login(){
      
      
      // check if there already is a school with this credentials
      
      if(this.updated){
        
        this.update()
        return;
      }

      this.button_active=false;

      this.$store.dispatch('login', { school: this.school } ).then(
        ()=>{
          this.$store.dispatch('setActiveSchool', this.school )

           this.login_done();

           this.button_active=true;
         //
         
        },()=>{
          //console.log("loggin unsuccessful")
          this.button_active=true;
          this.updated=false;
        })
      
    },
    login_done(){
      
     
      eventBus.$emit("saveSettings");
      
    },
    togglePasswordShow(){
      this.show_password=!this.show_password;
    },
    secureAlert(){
      modalService.createAlert(i18n.t('language.connection_is_secure'));
    },
    isSecure(){
      if(this.school.protocol==="https://"){
        return true;
      }else{
        return false;
      }
    },
    checkActive(){
      return this.school.active ? true: false;
    },

   change(){
     if(this.updated){
       return;
     }
     this.$emit('update')
     this.schoolActive=false;
     this.updated=true;
    
   }
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*
.container{
  padding:10px;
  border:10px solid #FF0000;
  border-radius:4px;
  margin-bottom:10px;
  position:relative;
}
*/

.btn{
  display:none;
}
.btn-visible{
  display:block;
}

#current_loggedin{
  flex:1;
}
#url{
  flex:1;
}
#user-name{
  margin-bottom:10px;
}
.icon{
  cursor:pointer;
  margin-left:5px!important;
}
.toolbar{
  position:absolute;
  top:10px;
  right:10px;
  display:inline-flex;
}
.logged-in{
  border:1px solid #00DD00;
}
.no-opacity{
  opacity:0;
}

.www{
  color:#707070;
}
</style>
